@if (showSection) {
  <div>
    <hr class="mb-2" />
    @if (!showAddOutreachAttemptEvidenceForm) {
      <div class="row">
        <div class="col-4">
          <div class="row">
            <div class="col-6">
              <strong>Outreach Attempt Evidence</strong>
            </div>
            @if (!outreachAttemptEvidence) {
              <div class="col-6 add-outreach-attempt-evidence">
                <a href="#" (click)="onAddOutReachAttemptEvidenceClick($event)">
                  Use Outreach Attempt Evidence
                </a>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (showAddOutreachAttemptEvidenceForm) {
      <div class="row">
        <div class="col-8">
          <h4>Outreach Attempt Evidence</h4>
          <app-outreach-attempt-evidence-form
            [capture]="capture"
            (newPatientAttachment)="onNewPatientAttachment($event)"
            (canceled)="onAddOutReachAttemptEvidenceCanceled()" />
        </div>
      </div>
    }
  </div>
}

@if (outreachAttemptEvidence) {
  <div class="row">
    <div class="col-8">
      <app-outreach-attempt-evidence
        [outreachAttemptEvidence]="outreachAttemptEvidence"
        [provider]="capture.provider"
        [patientPrescriberId]="capture.patientPrescriberId" />
    </div>
  </div>
}
